import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  constructor() { }
  services: boolean;
  activeElement: string = 'service';


  ngOnInit(): void {
    this.scroll();
  }

  scroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  _getTitle(){
    if(this.services){
      return 'Be a part of our high performing team';
    } else {
      return 'We would love to hear from you';
    }
  }

  onChange(str) {
    if(str == 'service') {
      this.activeElement = 'service';
      this.services = false;
    } else {
      this.activeElement = 'team';
      this.services = true;
    }
  }
}
